import React from 'react';
export const PresenceContext = React.createContext(undefined);
export function usePresenceContext() {
    const context = React.useContext(PresenceContext);
    if (!context) {
        throw new Error('PresenceContext not provided.');
    }
    return context;
}
//# sourceMappingURL=PresenceContext.js.map